import React, { Component, PropTypes } from 'react'
import Helmet from 'react-helmet'
import { Link as RouterLink } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'

import { colors, breakpoints } from '../constants/theme'

import Section from '../components/Section'
import Column from '../components/Column'
import Row from '../components/Row'
import Spacer from '../components/Spacer'
import Container from '../components/Container'
import Page from '../components/Page'
import Icon from '../components/Icon'
import Image from '../components/Image'

import Heading1 from '../styleguide/Heading1'
import Heading2 from '../styleguide/Heading2'
import Heading3 from '../styleguide/Heading3'
import Heading4 from '../styleguide/Heading4'
import Heading5 from '../styleguide/Heading5'
import Heading6 from '../styleguide/Heading6'
import Paragraph from '../styleguide/Paragraph'
import Navigation from '../styleguide/Navigation'
import Link from '../styleguide/Link'
import LinkList from '../styleguide/LinkList'
import Footer from '../styleguide/Footer'
import Subtext from '../styleguide/Subtext'
import Services from '../styleguide/Services'
import Quote from '../styleguide/Quote'
import QuoteAuthor from '../styleguide/QuoteAuthor'
import Button from '../styleguide/Button'
import Line from '../styleguide/Line'

import FelaProvider from '../containers/FelaProvider'

const { min1920, min1440, min1024, min768, min480, min360 } = breakpoints

const metaData = [
  {
    name: 'description',
    content:
      'Wir konzipieren, designen, entwickeln und betreiben anspruchsvolle Applikationen sowie komplexe und skalierbare Client-Server Systeme auf aktuellsten Web Stacks.'
  },
  {
    name: 'keywords',
    content: 'web agency'
  }
]

const Navigator = () => (
  <Page
    id="navigation"
    style={{
      position: 'fixed',
      zIndex: 10,
      transformStyle: 'preserve-3d'
    }}
  >
    <Container color="white" flex="0 0 auto">
      <Helmet title="Ninja Concept | Sophisticated web &amp; mobile applications" meta={metaData} />
      <Row alignItems="center" justifyContent="flex-start" style={{ alignItems: 'flex-start' }}>
        <Column
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-start'
          }}
          alignItems="center"
        >
          <img
            src={prefixLink('/images/logo/logo_ninjaconcept_horizontal.svg')}
            style={{ cursor: 'pointer' }}
            onClick={() => (window.location.pathname = '/')}
          />
          <Spacer size={20} />
          <RouterLink to={prefixLink('/')}>
            <Navigation
              bold
              color="white"
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'flex-start'
              }}
            >
              <i
                className="fa fa-angle-left"
                aria-hidden="true"
                style={{
                  fontSize: 30,
                  marginTop: -4
                }}
              />
              <Spacer size={6} /> HOME
            </Navigation>
          </RouterLink>
        </Column>
      </Row>
    </Container>
  </Page>
)

const Datenschutz = (props, { width }) => (
  <FelaProvider>
    <Navigator />
    <Image
      id="headerImage"
      style={{ width: '100%' }}
      jpg
      base={prefixLink('/images/images/impressum')}
      sizes={[min360, min480, min768, min1024, min1440]}
    />
    <Page bgColor={colors.background}>
      <Container flex="1 0 auto" color="white">
        <Spacer size={60} sizes={{ [min1024]: 100 }} />
        <Row columns={{ [min1920]: 12 }}>
          <Column style={{ alignItems: 'flex-start' }} sizes={{ [min1920]: 12 }}>
            <Heading2 style={{ textAlign: 'left' }}>Datenschutzerklärung</Heading2>
          </Column>
        </Row>

        <Spacer
          size={60}
          sizes={{
            [min1024]: 60,
            [min1920]: 60
          }}
        />
        <Row columns={{ [min768]: 12 }}>
          <Column
            style={{ alignItems: 'flex-start' }}
            sizes={{
              [min768]: 12,
              [min1440]: 10
            }}
          >
            <h2>Allgemeines</h2>
            <p>
              Datenschutz hat einen besonders hohen Stellenwert für die NinjaConcept GmbH. Mittels
              dieser einfach lesbaren und verständlichen Datenschutzerklärung möchte die
              NinjaConcept GmbH die Nutzer dieser Website über Art, Umfang und Zweck der Erhebung
              und Verwendung personenbezogener Daten sowie über die Verarbeitung ihrer Daten in
              Staaten außerhalb der Europäischen Union/des Europäischen Wirtschaftsraums
              unterrichten; ferner klärt die NinjaConcept GmbH die Nutzer über ihre bestehende
              Rechte auf.
            </p>
            <br />
            <h2>1. Name und Anschrift des für die Verarbeitung Verantwortlichen</h2>
            <p>
              Diensteanbieter gem. § 13 Telemediengesetz (TMG) und verantwortliche Stelle gem. § 3
              Abs. 7 Bundesdatenschutzgesetz (BDSG) ist:
              <p>
                <br />
                NinjaConcept GmbH<br />
                Haid-und-Neu-Str. 18<br />
                76131 Karlsruhe<br />
                Deutschland<br />
                Fon: +49 721 1803523-0<br />
                Mail: info@ninjaconcept.com
                <br /> <br />
              </p>
              Die NinjaConept GmbH gewinnt über Ihre Webseite neue Kunden.
            </p>

            <br />

            <h2>2. Datensicherheit</h2>
            <p>
              Die NinjaConcept GmbH hat zahlreiche technische und organisatorische Maßnahmen
              umgesetzt, um einen möglichst lückenlosen Schutz der über diese Website verarbeiteten
              personenbezogenen Daten sicherzustellen. Diese Maßnahmen entsprechen dem aktuellen
              Stand der Technik zur Gewährleistung der Datensicherheit.
              <br />
              <br />
              Dennoch können internetbasierte Datenübertragungen grundsätzlich Sicherheitslücken
              aufweisen, sodass ein absoluter Schutz nicht gewährleistet werden kann. Die
              NinjaConcept GmbH wird die Datenschutzerklärung den rechtlichen und
              sicherheitstechnischen Entwicklungen kontinuierlich anpassen und weiter verbessern.
              Sie können jede Änderung nachvollziehen, indem Sie die jeweils aktuelle Fassung
              abspeichern und mit einer späteren Version vergleichen.
            </p>
            <br />

            <h2>3. Cookies</h2>
            <p>
              Die Website der NinjaConcept GmbH verwendet Cookies.
              <br />
              <br />
              Cookies sind Textdateien, welche über einen Internetbrowser auf einem Computersystem
              abgelegt und gespeichert werden. Teilweise enthalten diese Cookies eine sogenannte
              Cookie-ID. Eine Cookie-ID ist eine eindeutige Kennung des Cookies. Sie besteht aus
              einer Zeichenfolge, durch welche Webseiten und Server dem konkreten Internetbrowser
              auf dem System des Nutzers zugeordnet werden können, in dem das Cookie gespeichert
              wurde. Dies ermöglicht es den besuchten Webseiten und Servern, den individuellen
              Browser des Nutzers von anderen Internetbrowsern, die andere Cookies enthalten, zu
              unterscheiden. Ein bestimmter Internetbrowser kann über die eindeutige Cookie-ID
              wiedererkannt und identifiziert werden.
              <br />
              <br />
              Durch den Einsatz von Cookies kann die NinjaConcept GmbH den Nutzern dieser Website
              nutzerfreundlichere Services bereitstellen, die ohne die Cookie-Setzung nicht möglich
              sind. Mittels eines Cookies können die Informationen und Angebote auf unserer Website
              im Sinne des Benutzers optimiert werden. Der Nutzer einer Website, die Cookies
              verwendet, muss beispielsweise nicht während seines Besuches der Website dort
              vorhandene Formulare, die er bereits ausgefüllt hat, nochmals ausfüllen.
              <br />
              <br />
              Der Nutzer kann die Setzung von Cookies durch unsere Website jederzeit mittels einer
              entsprechenden Einstellung des genutzten Internetbrowsers verhindern und damit der
              Setzung von Cookies dauerhaft widersprechen. Ferner können bereits gesetzte Cookies
              jederzeit über einen gängigen Internetbrowser oder andere Software gelöscht werden.
              Deaktiviert der Nutzer die Setzung von Cookies in dem genutzten Internetbrowser, sind
              unter Umständen nicht alle Funktionen unserer Website vollumfänglich nutzbar.
            </p>
            <br />
            <h2>
              4. Datenschutzbestimmungen zu Einsatz und Verwendung von Google Analytics (mit
              Anonymisierungsfunktion):
            </h2>
            <p>
              Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc.
              („Google“). Die Benutzung erfolgt auf der Grundlage des Art. 6 Abs. 1 S. 1 lit. f.
              DSGVO. Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer
              gespeichert werden und die eine Analyse der Benutzung der Webseite durch Sie
              ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung der
              Webseite wie
              <br />
              <br />
              Browser-Typ/-Version,<br />
              verwendetes Betriebssystem,<br />
              Referrer-URL (die zuvor besuchte Seite),<br />
              Hostname des zugreifenden Rechners (IP-Adresse),<br />
              Uhrzeit der Serveranfrage,<br />
              werden in der Regel an einen Server von Google in den USA übertragen und dort
              gespeichert. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte
              IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Wir haben zudem
              auf dieser Webseite Google Analytics um den Code „anonymizeIP“ erweitert. Dies
              garantiert die Maskierung Ihrer IP-Adresse, sodass alle Daten anonym erhoben werden.
              Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA
              übertragen und dort gekürzt.
              <br />
              <br />
              Im Auftrag des Betreibers dieser Website wird Google diese Information benutzen, um
              Ihre Nutzung der Webseite auszuwerten, um Reports über die Webseiten-Aktivitäten
              zusammenzustellen und um weitere mit der Webseiten-Nutzung und der Internetnutzung
              verbundene Dienstleistungen gegenüber dem Webseitenbetreiber zu erbringen. Sie können
              die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
              Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
              möglicherweise nicht sämtliche Funktionen dieser Webseite vollumfänglich werden nutzen
              können.
              <br />
              <br />
              Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre
              Nutzung der Webseite bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
              Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden
              Link verfügbare Browser-Plugin herunterladen und installieren:{' '}
              <a
                href="http://tools.google.com/dlpage/gaoptout?hl=de"
                target="_blank"
                rel="noopener noreferrer"
              >
                http://tools.google.com/dlpage/gaoptout?hl=de
              </a>. Alternativ zum Browser-Add-On, insbesondere bei Browsern auf mobilen Endgeräten,
              können Sie die Erfassung durch Google Analytics zudem verhindern, indem Sie auf diesen
              Link klicken. Es wird ein Opt-Out-Cookie gesetzt, das die zukünftige Erfassung Ihrer
              Daten beim Besuch dieser Website verhindert. Der Opt-Out-Cookie gilt nur in diesem
              Browser und nur für unsere Website und wird auf Ihrem Gerät abgelegt. Löschen Sie die
              Cookies in diesem Browser, müssen Sie das Opt-Out-Cookie erneut setzen. [Anm. Hinweise
              zur Einbindung des Opt-Out-Cookie finden Sie unter:<br />
              <a
                href="https://developers.google.com/analytics/devguides/collection/gajs/?hl=de#disable"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://developers.google.com/analytics/devguides/collection/gajs/?hl=de#disable
              </a>
              <br />
              <br />
              Wir nutzen Google Analytics weiterhin dazu, Daten aus Double-Click-Cookies und auch
              AdWords zu statistischen Zwecken auszuwerten. Sollten Sie dies nicht wünschen, können
              Sie dies über den Anzeigenvorgaben-Manager{' '}
              <a
                href="http://www.google.com/settings/ads/onweb/?hl=de"
                target="_blank"
                rel="noopener noreferrer"
              >
                (http://www.google.com/settings/ads/onweb/?hl=de)
              </a>{' '}
              deaktivieren.
              <br />
              <br />
              Weitere Informationen zum Datenschutz im Zusammenhang mit Google Analytics finden Sie
              etwa in der Google Analytics-Hilfe<br />
              <a
                href="https://support.google.com/analytics/answer/6004245?hl=de"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://support.google.com/analytics/answer/6004245?hl=de
              </a>
            </p>

            <br />

            <h2>5. Datenschutzbestimmungen zu Einsatz und Verwendung von Google AdWords</h2>
            <p>
              Die NinjaConcept GmbH hat auf dieser Website Google AdWords integriert. Google AdWords
              ist ein Dienst zur Internetwerbung, der es Werbetreibenden gestattet, sowohl Anzeigen
              in den Suchmaschinenergebnissen von Google als auch im Google-Werbenetzwerk zu
              schalten. Google AdWords ermöglicht es einem Werbetreibenden, vorab bestimmte
              Schlüsselwörter festzulegen, mittels derer eine Anzeige in den
              Suchmaschinenergebnissen von Google ausschließlich dann angezeigt wird, wenn der
              Nutzer mit der Suchmaschine ein schlüsselwortrelevantes Suchergebnis abruft. Im
              Google-Werbenetzwerk werden die Anzeigen mittels eines automatischen Algorithmus und
              unter Beachtung der zuvor festgelegten Schlüsselwörter auf themenrelevanten Webseiten
              verteilt.
              <br />
              <br />
              Betreibergesellschaft der Dienste von Google AdWords ist die Google Inc., 1600
              Amphitheatre Pkwy, Mountain View, CA 94043-1351, USA.
              <br />
              <br />
              Der Zweck von Google AdWords ist die Bewerbung unserer Website durch die Einblendung
              von interessenrelevanter Werbung auf den Webseiten von Drittunternehmen und in den
              Suchmaschinenergebnissen der Suchmaschine Google.
              <br />
              <br />
              Gelangt ein Nutzer über eine Google-Anzeige auf unsere Website, wird auf dem
              informationstechnologischen System des Nutzers durch Google ein sogenannter
              Conversion-Cookie abgelegt. Was Cookies sind, wurde oben bereits erläutert. Ein
              Conversion-Cookie verliert nach dreißig Tagen seine Gültigkeit und dient nicht zur
              Identifikation der betroffenen Person. Über den Conversion-Cookie wird, sofern das
              Cookie noch nicht abgelaufen ist, nachvollzogen, ob bestimmte Unterseiten,
              beispielsweise ein Versicherungsantrag, auf unserer Website aufgerufen wurden. Durch
              den Conversion-Cookie können sowohl wir als auch Google nachvollziehen, ob ein Nutzer,
              der über eine AdWords-Anzeige auf unsere Website gelangt ist, einen Umsatz generierte,
              also einen Versicherungsantrags-Prozess beendet oder abgebrochen hat
              <br />
              <br />
              Die durch die Nutzung des Conversion-Cookies erhobenen Daten und Informationen werden
              von Google verwendet, um Besuchsstatistiken für unsere Website zu erstellen. Diese
              Besuchsstatistiken werden durch uns wiederum genutzt, um die Gesamtanzahl der Nutzer
              zu ermitteln, welche über AdWords-Anzeigen an uns vermittelt wurden, also um den
              Erfolg oder Misserfolg der jeweiligen AdWords-Anzeige zu ermitteln und um unsere
              AdWords-Anzeigen für die Zukunft zu optimieren. Weder unser Unternehmen noch andere
              Werbekunden von Google AdWords erhalten Informationen von Google, mittels derer der
              Nutzer identifiziert werden könnte.
              <br />
              <br />
              Mittels des Conversion-Cookies werden personenbezogene Informationen, beispielsweise
              die durch den Nutzer besuchten Webseiten, gespeichert. Bei jedem Besuch unserer
              Webseiten werden demnach personenbezogene Daten, einschließlich der IP-Adresse des vom
              Nutzer genutzten Internetanschlusses, an Google in den Vereinigten Staaten von Amerika
              übertragen und von Google dort gespeichert. Google gibt diese über das technische
              Verfahren erhobenen personenbezogenen Daten unter Umständen an Dritte weiter.
              <br />
              <br />
              Der Nutzer kann die Setzung von Cookies durch unsere Internetseite, wie oben bereits
              dargestellt, jederzeit mittels einer entsprechenden Einstellung des genutzten
              Internetbrowsers verhindern und damit der Setzung von Cookies dauerhaft widersprechen.
              Eine solche Einstellung des genutzten Internetbrowsers würde auch verhindern, dass
              Google einen Conversion-Cookie auf dem informationstechnologischen System des Nutzers
              setzt. Zudem kann ein von Google AdWords bereits gesetzter Cookie jederzeit über den
              Internetbrowser oder andere Software gelöscht werden.
              <br />
              <br />
              Ferner besteht für den Nutzer die Möglichkeit, der interessenbezogenen Werbung durch
              Google zu widersprechen. Hierzu muss der Nutzer von jedem der von ihm genutzten
              Internetbrowser aus den Link www.google.de/settings/ads aufrufen und dort die
              gewünschten Einstellungen vornehmen.
              <br />
              <br />
              Weitere Informationen und die geltenden Datenschutzbestimmungen von Google können
              unter{' '}
              <a
                href="https://www.google.de/intl/de/policies/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.google.de/intl/de/policies/privacy/
              </a>{' '}
              abgerufen werden.
            </p>
          </Column>
          <Column sizes={{ [min1440]: 2 }} />
        </Row>
      </Container>
    </Page>
    <Spacer size={100} />
    <Line width="100%" stroke={1} color="rgba(255, 255, 255, 0.4)" />
    <Page height="0%" data-scroll-scope="contact" bgColor={colors.background}>
      <Spacer size={160} />
      <Container color="white" flex="1 0 auto">
        <Row center>
          <Column>
            <Section alignSelf="stretch" flex="1 0 auto" center>
              <Image svg base={prefixLink('/images/logo/logo_ninjaconcept_horizontal')} />
            </Section>
            <Spacer size={64} />
            <Footer bold textAlign="center">
              © 2016-2024 NinjaConcept GmbH
            </Footer>
            <Footer textAlign="center">
              The design of ninjaconcept is a registered trademark of NinjaConcept GmbH.
              <br />Hardtstraße 37A, 76185 Karlsruhe, Germany
            </Footer>
            <Section flex alignSelf="stretch" center row columnOnSmall>
              <Footer bold>
                <a href="tel:+49 721 180 352 30">+49 721 180 352 30</a>
              </Footer>
              <Spacer size={0} sizes={{ [min768]: 18 }} />
              <Footer bold>
                <a href="mailto:contact@ninjaconcept.com">contact@ninjaconcept.com</a>
              </Footer>
              <Spacer size={0} sizes={{ [min768]: 18 }} />
              <RouterLink to={prefixLink('/impressum/')}>
                <Footer bold>Impressum</Footer>
              </RouterLink>
              <Spacer size={0} sizes={{ [min768]: 18 }} />
              <Footer bold color="gray">
                Datenschutzerklärung
              </Footer>
            </Section>
            <Spacer
              size={40}
              sizes={{
                [min768]: 48,
                [min1440]: 60
              }}
            />
          </Column>
        </Row>
      </Container>
      <Spacer
        size={60}
        sizes={{
          [min1440]: 68,
          [min1920]: 76
        }}
      />
    </Page>
  </FelaProvider>
)

Datenschutz.contextTypes = { width: PropTypes.number }

class DeviceProvider extends Component {
  static childContextTypes = { width: PropTypes.number }

  constructor(props, context) {
    super(props, context)
    this.distance = 0
    this.state = { width: 0 }
  }

  updateDevice = () => {
    this.setState({ width: window.innerWidth })
  }

  draw = () => {
    window.requestAnimationFrame(this.draw)
    this.animate()
  }

  animate = () => {
    const scrollTop = this.mount.scrollTop

    const offset =
      scrollTop > this.mount.scrollHeight - window.innerHeight ? 0 : this.lastScrollTop - scrollTop

    const newDirection = offset < 0 ? 'down' : offset > 0 ? 'up' : this.direction

    if (newDirection === this.direction && Date.now() >= window.IS_SCROLLING) {
      this.distance += Math.abs(offset)
    } else {
      this.distance = 0
    }

    if (Date.now() > window.LAST_SCROLL + 1000) {
      this.distance = 0
    }

    this.direction = newDirection

    this.lastScrollTop = scrollTop
    const scrollPercentage = scrollTop / (this.headerImage.offsetHeight - 40)

    this.nav.style.backgroundColor = `rgba(22, 24, 28, ${Math.max(
      0,
      Math.min(1.0, scrollPercentage)
    )})`

    if (this.direction === 'up' && this.distance > 200) {
      (this.nav.style.transition = '200ms transform linear'),
        (this.nav.style.transform = 'translate3d(0, 0, 0)')
    }

    if (
      ((this.direction === 'down' && this.distance > 70) ||
        Date.now() > window.LAST_SCROLL + 3500) &&
      scrollTop > this.headerImage.offsetHeight - 40
    ) {
      (this.nav.style.transition = '200ms transform linear'),
        (this.nav.style.transform = `translate3d(0, -${this.nav.offsetHeight}px, 0)`)
    }

    window.LAST_SCROLL = Date.now()
  }

  getChildContext() {
    return { width: this.state.width }
  }

  componentDidMount() {
    this.mount = document.getElementById('react-mount')
    this.nav = document.getElementById('navigation')
    this.nav.classList.add('animated')
    this.headerImage = document.getElementById('headerImage')
    this.lastScrollTop = this.mount.scrollTop
    window.IS_SCROLLING = Date.now()

    this.draw()
    this.updateDevice()

    window.addEventListener('resize', () => {
      this.updateDevice()
    })
  }

  render() {
    return this.props.children
  }
}

export default () => (
  <DeviceProvider>
    <Datenschutz />
  </DeviceProvider>
)



// WEBPACK FOOTER //
// ./datenschutz.js